module.exports = __webpack_public_path__ + "img/send.4e865e78.svg";